import React from "react";
import './CSS/custom.css'

const Footer = () => {
    return(
        <p className="foot">Copyright &copy; 2023 Aldi Prasetyo Widodo</p>
    )
}

export default Footer;